// popover.js tells the page when its overlay shows a recipe and when it is
// closed, so pixie.js can step aside while the video plays.
export const POPOVER_OPEN_EVENT = "pixmoto:popover-open";
export const POPOVER_CLOSE_EVENT = "pixmoto:popover-close";

export function announce(type: string) {
  try {
    window.dispatchEvent(new Event(type));
  } catch {
    /* no Event constructor (IE11), and no pixie.js there to listen */
  }
}
